/**
 * Tiny dev-only logger.
 *
 * Use inside catch blocks to surface unexpected errors during development
 * without spamming production browser consoles. Safe to call when
 * `process` is undefined (e.g. inside Jest, edge bundles).
 */
export function devWarn(...args) {
  try {
    const isProd = typeof process !== "undefined"
      && process.env
      && process.env.NODE_ENV === "production";
    if (isProd) return;
    // eslint-disable-next-line no-console
    console.warn("[doing-good]", ...args);
  } catch {
    // never throw from a logger
  }
}
